import PNG from "../../../assets/images/raster/components/Idea/Idea@2x.png";
import PNG_1200 from "../../../assets/images/raster/components/Idea/Idea@1200_2x.png";
import PNG_992 from "../../../assets/images/raster/components/Idea/Idea@992_2x.png";
import PNG_mob from "../../../assets/images/raster/components/Idea/Idea@mob_2x.png";
import WEBP from "../../../assets/images/raster/components/Idea/Idea@2x.webp";
import WEBP_1200 from "../../../assets/images/raster/components/Idea/Idea@1200_2x.webp";
import WEBP_992 from "../../../assets/images/raster/components/Idea/Idea@992_2x.webp";
import WEBP_mob from "../../../assets/images/raster/components/Idea/Idea@mob_2x.webp";

export const SCREEN = {
  PNG,
  PNG_1200,
  PNG_992,
  PNG_768: PNG,
  PNG_mob,
  WEBP,
  WEBP_1200,
  WEBP_992,
  WEBP_768: WEBP,
  WEBP_mob,
};

